import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-8c2602de"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teacher-main-wrapper"
};
const _hoisted_2 = {
  class: "teacher-wrapper"
};
const _hoisted_3 = {
  class: "page-title"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-bottom": "-8px"
  },
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#0044EC"
  }
}, "教学"), /*#__PURE__*/_createTextVNode("名师 ")], -1));

const _hoisted_5 = ["href"];

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 更多");

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "16",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202411/ef8515601c4445a596596889eea52307.png",
  alt: ""
}, null, -1));

const _hoisted_8 = [_hoisted_6, _hoisted_7];

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));

const _hoisted_10 = {
  class: "teacher-list"
};
const _hoisted_11 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_swiperTeacherList = _resolveComponent("swiperTeacherList");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("a", {
    href: `/teacherList.html?name=${$props.menu.menu_name}&menuId=${$props.menu.id}`,
    class: "more"
  }, _hoisted_8, 8, _hoisted_5), _hoisted_9]), _createElementVNode("div", _hoisted_10, [$data.teacherList && $data.teacherList.length ? (_openBlock(), _createBlock(_component_swiperTeacherList, {
    key: 0,
    teacherList: $data.teacherList
  }, null, 8, ["teacherList"])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_Empty, {
    type: "people"
  })]))])])]);
}